const VendorPartsData = [
  {
    link: "/vendor/manitowoc-ice.html",
    shopAllLink: "/59179/shop-all-manitowoc-ice-parts.html",
  },
  {
    link: "/vendor/ice-o-matic.html",
    shopAllLink: "/57631/shop-all-ice-o-matic-parts.html",
  },
  {
    link: "/vendor/follett-corporation.html",
    shopAllLink: "/57627/shop-all-follett-parts.html",
  },
  {
    link: "/vendor/vitamix.html",
    shopAllLink:
      "/35099/commercial-blender-parts-and-accessories.html?vendor=Vitamix",
  },
  {
    link: "/vendor/insinkerator.html",
    shopAllLink: "/57657/shop-all-insinkerator-parts.html",
  },
  {
    link: "/vendor/hobart.html",
    shopAllLink: "/57653/shop-all-hobart-parts.html",
  },
  {
    link: "/vendor/bunn.html",
    shopAllLink: "/58173/shop-all-bunn-parts.html",
  },
  {
    link: "/vendor/bakers-pride.html",
    shopAllLink: "/61239/shop-all-bakers-pride-parts.html",
  },
  {
    link: "/vendor/berkel.html",
    shopAllLink: "/58671/shop-all-berkel-parts.html",
  },
  {
    link: "/vendor/cleveland.html",
    shopAllLink: "/61191/shop-all-cleveland-parts.html",
  },
  {
    link: "/vendor/cornelius.html",
    shopAllLink: "/61223/shop-all-cornelius-parts.html",
  },
  {
    link: "/vendor/fetco.html",
    shopAllLink: "/59183/shop-all-fetco-parts.html",
  },
  {
    link: "/vendor/globe.html",
    shopAllLink: "/58683/shop-all-globe-parts.html",
  },
  {
    link: "/vendor/grindmaster-cecilware.html",
    shopAllLink: "/58685/shop-all-grindmaster-cecilware-parts.html",
  },
  {
    link: "/vendor/kitchenaid.html",
    shopAllLink: "/37913/kitchenaid-mixer-accessories.html",
  },
  {
    link: "/vendor/master-bilt.html",
    shopAllLink: "/59181/shop-all-master-bilt-parts.html",
  },
  {
    link: "/vendor/merrychef.html",
    shopAllLink: "/61177/shop-all-merrychef-parts.html",
  },
  {
    link: "/vendor/micro-matic.html",
    shopAllLink: "/59159/shop-all-micro-matic-parts.html",
  },
  {
    link: "/vendor/norlake.html",
    shopAllLink: "/61251/shop-all-nor-lake-parts.html",
  },
  {
    link: "/vendor/notrax.html",
    shopAllLink: "/61237/shop-all-notrax-parts.html",
  },
  {
    link: "/vendor/rational.html",
    shopAllLink: "/59141/shop-all-rational-parts.html",
  },
  {
    link: "/vendor/sammic.html",
    shopAllLink: "/61199/shop-all-sammic-parts.html",
  },
  {
    link: "/vendor/servend.html",
    shopAllLink: "/61203/shop-all-servend-parts.html",
  },
  {
    link: "/vendor/tablecraft.html",
    shopAllLink: "/61243/shop-all-tablecraft-parts.html",
  },
  {
    link: "/vendor/turbo-air-refrigeration.html",
    shopAllLink: "/61193/shop-all-turbo-air-refrigeration-parts.html",
  },
  {
    link: "/vendor/turbochef.html",
    shopAllLink: "/61161/shop-all-turbochef-parts.html",
  },
  {
    link: "/vendor/vacmaster.html",
    shopAllLink: "/61173/shop-all-vacmaster-parts.html",
  },
  {
    link: "/vendor/wells.html",
    shopAllLink: "/61167/shop-all-wells-parts.html",
  },
  {
    link: "/vendor/wilbur-curtis.html",
    shopAllLink: "/61205/shop-all-wilbur-curtis-parts.html",
  },
  {
    link: "/vendor/allpoints.html",
    shopAllLink: "/68457/shop-all-allpoints-parts.html",
  },
  {
    link: "/vendor/imperial-range.html",
    shopAllLink: "/68465/shop-all-imperial-range-parts.html",
  },
  {
    link: "/vendor/carrier.html",
    shopAllLink: "/68857/shop-all-carrier-parts.html",
  },
  {
    link: "/vendor/electrolux.html",
    shopAllLink: "/68861/shop-all-electrolux-parts.html",
  },
  {
    link: "/vendor/franke.html",
    shopAllLink: "/68863/shop-all-franke-parts.html",
  },
];
export default VendorPartsData;
